import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import {
    StyledDotContainer,
    StyledDot,
    StyledDotButton,
    StyledArrowContainer,
    StyledArrow,
    StyledArrowComponent,
    StyledComponentWrapper,
} from './simple-gallery.style';
import { theme } from '../../../style/global-style';
import { IGalleryProps } from './ISimpleGallery';

export const SimpleGallery = ({
    children,
    showDots = true,
    showFadedArrow = false,
    arrowColor = theme.shades.white,
    style,
    showShadow = false,
}: IGalleryProps) => {
    const [view, setView] = React.useState(0);

    const handleNextClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (view < children.length - 1) {
            setView(view + 1);
        }
    };

    const handlePrevClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (view > 0) {
            setView(view - 1);
        }
    };

    const isStartItem = view === 0;
    const isLastItem = view === children.length - 1;
    return (
        <StyledComponentWrapper
            data-testid={'simple-gallery'}
            style={{ position: 'relative', WebkitOverflowScrolling: 'touch', ...style }}
        >
            {children.length > 1 ? (
                <StyledArrowContainer>
                    <StyledArrow
                        data-testid={'simple-gallery-arrow-left'}
                        onClick={(e: React.MouseEvent) => handlePrevClick(e)}
                        showfadedarrow={showFadedArrow ? 'true' : undefined}
                        startitem={String(isStartItem)}
                        // @TODO: these will have to be translated
                        aria-label="previous"
                    >
                        <StyledArrowComponent
                            showShadow={showShadow}
                            orientation={'left'}
                            fill={arrowColor}
                            showfadedarrow={showFadedArrow ? 'true' : undefined}
                            startitem={String(isStartItem)}
                        />
                    </StyledArrow>
                    <StyledArrow
                        data-testid={'simple-gallery-arrow-right'}
                        onClick={(e: React.MouseEvent) => handleNextClick(e)}
                        showfadedarrow={showFadedArrow ? 'true' : undefined}
                        lastitem={String(isLastItem)}
                        // @TODO: these will have to be translated
                        aria-label="next"
                    >
                        <StyledArrowComponent
                            showShadow={showShadow}
                            orientation={'right'}
                            fill={arrowColor}
                            showfadedarrow={showFadedArrow ? 'true' : undefined}
                            lastitem={String(isLastItem)}
                        />
                    </StyledArrow>
                </StyledArrowContainer>
            ) : null}

            <SwipeableViews
                enableMouseEvents={true}
                index={view}
                onChangeIndex={(index) => {
                    setView(index);
                }}
            >
                {children}
            </SwipeableViews>

            {showDots && (
                <StyledDotContainer data-testid={'simple-gallery-dots'}>
                    {children &&
                        children.length > 1 &&
                        children.map((_, i) => {
                            return (
                                <StyledDotButton key={`dot-${i}`} onClick={() => setView(i)}>
                                    <StyledDot
                                        key={`klick-dot-${i}`}
                                        data-testid={`simple-gallery-dot-${i + 1}`}
                                        active={i === view ? true : false}
                                        aria-selected={i === view ? true : false}
                                    >
                                        {' '}
                                    </StyledDot>
                                </StyledDotButton>
                            );
                        })}
                </StyledDotContainer>
            )}
        </StyledComponentWrapper>
    );
};
